// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2AuR9","label":"Labeled_label__1l0Oi","divider":"Labeled_divider__madhv"};